import React from "react";
import PodcastStudioAdmin from "../PodcastStudioSection/PodcastStudioAdmin";

const PodcastPending = () => {
  return <PodcastStudioAdmin />;
};

export default PodcastPending;
